import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { TeamSeasonStatsDTO } from '@solverml/api';

/**
 * Componente "Dumb" (Vista) que muestra las estadísticas
 * agregadas de un equipo (V/D/E, Goles) para una temporada.
 */
@Component({
  selector: 'app-team-season-summary',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatIconModule
  ],
  templateUrl: './team-season-summary.component.html',
  styleUrls: ['./team-season-summary.component.scss']
})
export class TeamSeasonSummaryComponent {

  /**
   * DTO con las estadísticas agregadas del equipo para la temporada.
   */
  @Input({ required: true }) stats!: TeamSeasonStatsDTO | null;

}
